import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getSizeGuide } from "../services/sizeGuideService";

export const fetchSizeGuideThunk = createAsyncThunk(
    "sizeGuide/fetch",
    async (_, { rejectWithValue }) => {
        try {
            const res = await getSizeGuide();
            return res?.data ?? res;
        } catch (err) {
            return rejectWithValue(
                err?.message || "Failed to fetch size guide"
            );
        }
    }
);

const initialState = {
    data: null,
    status: "idle", // idle | loading | succeeded | failed
    error: null,
};

const sizeGuideSlice = createSlice({
    name: "sizeGuide",
    initialState,
    reducers: {
        resetSizeGuide: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSizeGuideThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(fetchSizeGuideThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.data = action.payload;
            })
            .addCase(fetchSizeGuideThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            });
    },
});

export const { resetSizeGuide } = sizeGuideSlice.actions;
export default sizeGuideSlice.reducer;
